module.exports = __webpack_public_path__ + "static/fonts/Fact-ExtraLightItalic.94f86ec.woff";